import { IEventrActivity, IEventrHotel } from '@eventr/common'
import { useMemo } from 'react'

type ElementType = IEventrHotel | IEventrActivity

const SECTION_IDS = {
    FLIGHTS: 2,
    ACTIVITIES: 8,
}
export const useFilterElements = <T extends ElementType>(
    elements: T[],
    search: string,
    sectionID: number
) => {
    const lowerCaseSearch = search.toLowerCase().trim()

    const filteredElements = useMemo(() => {
        if (!lowerCaseSearch) {
            return elements
        }

        if (!elements) {
            return []
        }

        return elements.filter((element) => {
            switch (sectionID) {
                case SECTION_IDS.ACTIVITIES:
                    const activity = element as IEventrActivity
                    return (
                        activity.activity_name
                            ?.toLowerCase()
                            .includes(lowerCaseSearch) ||
                        activity.location
                            ?.toLowerCase()
                            .includes(lowerCaseSearch) ||
                        activity.description
                            ?.toLowerCase()
                            .includes(lowerCaseSearch) ||
                        activity.todo_description
                            ?.toLowerCase()
                            .includes(lowerCaseSearch) ||
                        activity.todo_name
                            ?.toLowerCase()
                            .includes(lowerCaseSearch)
                    )

                default:
                    return (
                        (element as any).name
                            ?.toLowerCase()
                            .includes(lowerCaseSearch) ||
                        (element as any).title
                            ?.toLowerCase()
                            .includes(lowerCaseSearch) ||
                        JSON.stringify(element)
                            .toLowerCase()
                            .includes(lowerCaseSearch) // Fallback: search in stringified object
                    )
            }
        })
    }, [elements, lowerCaseSearch, sectionID])

    return filteredElements
}
